import { SubscriptionState } from "../contracts/SubscriptionState";
import { SubscriptionStatusResponse } from "../contracts/SubscriptionStatusResponse";
import {
  SubscriptionStatus,
  TRIAL_URGENT_THRESHOLD_DAYS,
} from "../models/SubscriptionStatus";

export function mapResponseToSubscriptionStatus(
  response: SubscriptionStatusResponse
): SubscriptionStatus {
  const isTrialing = response.state === SubscriptionState.Trialing;
  return {
    state: response.state,
    trialStartedAt: new Date(response.trialStartedAt),
    trialEndsAt: new Date(response.trialEndsAt),
    trialDaysRemaining: response.trialDaysRemaining,
    complimentaryUntil: response.complimentaryUntil
      ? new Date(response.complimentaryUntil)
      : null,
    isFoundingMember: response.isFoundingMember,
    tier: response.tier,
    hasProviderSubscription: response.hasProviderSubscription,
    coveredByOrganization: response.coveredByOrganization,
    organizationName: response.organizationName,
    customMonthlyAmountMinorUnits: response.customMonthlyAmountMinorUnits,
    customAnnualAmountMinorUnits: response.customAnnualAmountMinorUnits,
    customPriceCurrency: response.customPriceCurrency,
    isReadOnly:
      response.state === SubscriptionState.ReadOnly ||
      response.state === SubscriptionState.Cancelled,
    isTrialing,
    isTrialUrgent:
      isTrialing && response.trialDaysRemaining <= TRIAL_URGENT_THRESHOLD_DAYS,
  };
}
